import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export type EstablishmentFormValues = {
  establishmentName: string;
  establishmentType: string;
  responsibleName: string;
  address: string;
  responsibleEmail: string;
  creditsIA: number;
  establishmentNumber: string;
  region?: string;
  category: string;
};

export const createEstablishmentValidationSchema = (
  requireRegion: boolean = false,
) =>
  yup.object({
    establishmentName: yup
      .string()
      .required("Le nom de l'établissement est requis"),
    establishmentType: yup
      .string()
      .required("Le type d'établissement est requis"),
    category: yup.string().required('La catégorie est requise'),
    responsibleName: yup.string().required('Le nom du responsable est requis'),
    address: yup.string().required("L'adresse est requise"),
    responsibleEmail: yup
      .string()
      .email('Email invalide')
      .required("L'email du responsable est requis"),
    creditsIA: yup
      .number()
      .required('Les crédits IA sont requis')
      .min(0, 'Les crédits doivent être positifs')
      .typeError('Les crédits IA doivent être un nombre'),
    establishmentNumber: yup
      .string()
      .required("Le numéro de l'établissement est requis"),
    region: requireRegion
      ? yup.string().required('La région est requise pour une nouvelle école')
      : yup.string().optional(),
  });

// Schema par défaut pour compatibilité
export const establishmentValidationSchema =
  createEstablishmentValidationSchema();

export const useEstablishmentForm = (requireRegion: boolean = false) => {
  const schema = createEstablishmentValidationSchema(requireRegion);
  const { handleSubmit, register, errors, reset, setValue, watch } =
    useFormHandler<EstablishmentFormValues>(schema);

  return { handleSubmit, register, errors, reset, setValue, watch };
};
